import { createElement, Component, PropTypes } from 'rlink-react';
import RecruitingJob from 'rlink-recruiting/RecruitingJob';
import groupJobsByDepartment from 'rlink-recruiting/groupJobsByDepartment';
import spliceJobPostings from 'rlink-recruiting/spliceJobPostings';
import NavLink from 'rlink-router/NavLink';
import themeable from 'rlink-theme/themeable';

import CategorizedJobs from 'components/Careers/CategorizedJobs';
import careersScene from 'helpers/scenes/careersScene';
import getArticleLoader from 'helpers/getArticleLoader';

const DEPARTMENTS_PER_ROW = 3;

export default class CareersPanel extends Component {
  hasJobPostings () {
    return this.props.jobPostings && this.props.jobPostings.length > 0;
  }

  initCareerScene () {
    if (this.hasJobPostings()) {
      careersScene();
    }
  }

  componentDidUpdate () {
    this.initCareerScene();
  }

  componentDidMount () {
    this.initCareerScene();
  }

  render () {
    const { theme, jobPostings } = this.props;
    const groupedJobPostings = spliceJobPostings(
      groupJobsByDepartment(jobPostings),
      DEPARTMENTS_PER_ROW
    );
    return (
      <section className="node node-single-page-section node-promoted view-mode-full">
        <article id="careers" className="layout-text bg-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Careers</h2>
              <div>
                <p>We take great pride in the work we do here at Relic. Not just pride in the games we create, but in the culture we foster, and in the community we’re part of both inside the studio and out. To be a Relican means you’re equally excited to share your ideas and listen to others. You bring your own unique experience, perspective, and voice to each project, because that unique voice is what will help us go beyond where we were before you arrived. More than anything, you bring passion, empathy, and kindness to work every day, and you leave ego and cynicism at the door.</p>
                <p>On our end, we do everything we can to remove barriers between doing what you love, and loving what you do. Inside the studio, we’ve redefined what it means to be a great Relican, and are introducing detailed guidelines for you to work with your manager so you always know where you are on your career path, and how we can work with you if you’d like to grow in to another discipline at Relic. We offer referral bonuses, a generous RRSP matching program, minimum three week vacation for full-time employees (plus a week off when we shut down for the holidays), and more.</p>
                <p>Outside the studio, we’re fortunate to be in one of the most beautiful cities in the world, and we don’t take it for granted. We partner with local restaurants and businesses for staff discounts, as well as fitness facilities and car share programs so you can get the most out of your city. Above all, we take pride in providing a healthy work-life balance so you can go out and enjoy all these great perks!</p>
                <p>If the idea of making great games with great people excites you, reach out! Check out our open roles below.</p>
                <p>
                  Please click this link to view our
                  {' '}
                  <NavLink
                    className={theme.CandidateNoticeLink}
                    href={{
                      view: 'home',
                      params: {slug: 'candidate-notice'},
                    }}
                    onClick={() => {
                      getArticleLoader().show(() => {
                        $('.ajax-node').hide();
                      });
                    }}>
                    Candidate Application Notice.
                  </NavLink>
                </p>
                <p>
                  <i>
                    NOTE: We've been made aware of emails claiming to be from
                    Relic and SEGA with fraudulent job interviews and offers
                    being sent out, and are looking into the situation. All of
                    Relic's Recruiting Team is public and searchable on LinkedIn.
                    We strongly encourage anyone who thinks they've received an
                    email from Relic to make sure it's from someone on our team,
                    and to reach out to that recruiter via private message if
                    you're at all unsure.
                  </i>
                </p>
              </div>
            </div>
          </div>
        </article>
        <article id="current-vacancies" className="layout-standard text-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Current Vacancies</h2>
              <div className="view view-job-positions view-id-job_positions view-display-id-job_directory view-dom-id-9a8d3df4af0440d1debae513c70fd82e">
                <div className="view-content">
                  {groupedJobPostings.map(jobRow => (
                    <div key={JSON.stringify(jobRow)} className="row">
                      {Object.entries(jobRow).map(([department, jobs]) => (
                        <CategorizedJobs
                          key={department}
                          category={department}
                          jobs={jobs} />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

CareersPanel.propTypes = {
  jobPostings: PropTypes.arrayOf(PropTypes.instanceOf(RecruitingJob)),
};

themeable(CareersPanel, {
  classes: [
    'CandidateNoticeLink',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/CareersPanel.jsx